// TODO: Workaround for Analytics. We need to allow for DOM events
// to reach the analytics event handlers before navigating.
// https://codepen.io/stiggler/pen/PRggZq
function withTimeout(fn) {
  return (...args) =>
    new Promise((resolve) => setTimeout(() => resolve(fn.apply(fn, args))));
}

export function mountFn(targetElement, props) {
  let unmount = null;
  let loaded = false;

  return async (mount, routerInterface) => {
    // 1. Remove the previous element from DOM
    // eslint-disable-next-line no-param-reassign
    targetElement.innerHTML = '';

    // 2. Run the unmount callback from the previous component
    if (unmount) {
      unmount();
    }

    // 3. Create a disposable child element
    const mountElement = document.createElement('div');
    targetElement.appendChild(mountElement);

    // 4. Mount the new component onto the child element
    // TODO: I assume this Promise is here for timing reasons. Should confirm
    // or take it out
    unmount = await Promise.resolve(
      mount(mountElement, props, routerInterface)
    );

    // 🚨 HACK ALERT 🚨
    if (!loaded) {
      loaded = true;
      targetElement.dispatchEvent(
        new Event('upd-app-loaded', { bubbles: true, composed: true })
      );
    }
  };
}

export function connectMount({ router, history, props, routes, element }) {
  const mount = mountFn(element, props);
  router.subscribe(({ newPath }) => {
    const routeConfig = routes.find(({ path }) => path === newPath);
    if (routeConfig) {
      const { mount: mountComponent, edges } = routeConfig;

      const routerInterface = {
        ...router,
        back: () => history.back(),
        edges: edges
          ? Object.keys(edges).reduce(
              (obj, key) => ({
                ...obj,
                [key]: () => withTimeout(router.go)(edges[key]),
              }),
              {}
            )
          : {},
      };

      mount(mountComponent, routerInterface);
    }
  });
}
